__turbopack_context__.v({
  "ctaGlow": "_1-sJLG_ctaGlow",
  "featureCard": "_1-sJLG_featureCard",
  "float": "_1-sJLG_float",
  "float-y": "_1-sJLG_float-y",
  "floatSlow": "_1-sJLG_floatSlow",
  "glassDark": "_1-sJLG_glassDark",
  "glassLight": "_1-sJLG_glassLight",
  "hero-in": "_1-sJLG_hero-in",
  "heroIn": "_1-sJLG_heroIn",
  "iconBtn": "_1-sJLG_iconBtn",
  "iconTile": "_1-sJLG_iconTile",
  "orb": "_1-sJLG_orb",
  "orb-drift": "_1-sJLG_orb-drift",
  "orbDrift": "_1-sJLG_orbDrift",
  "orbGold": "_1-sJLG_orbGold",
  "orbPrimary": "_1-sJLG_orbPrimary",
  "orbSecondary": "_1-sJLG_orbSecondary",
  "pager": "_1-sJLG_pager",
  "pagerDot": "_1-sJLG_pagerDot",
  "pagerDotActive": "_1-sJLG_pagerDotActive",
  "phoneFrame": "_1-sJLG_phoneFrame",
  "phoneGlare": "_1-sJLG_phoneGlare",
  "phoneGlow": "_1-sJLG_phoneGlow",
  "phoneNotch": "_1-sJLG_phoneNotch",
  "phoneScreen": "_1-sJLG_phoneScreen",
  "pulse-ring": "_1-sJLG_pulse-ring",
  "pulseRing": "_1-sJLG_pulseRing",
  "reveal": "_1-sJLG_reveal",
  "revealPop": "_1-sJLG_revealPop",
  "revealVisible": "_1-sJLG_revealVisible",
  "root": "_1-sJLG_root",
  "screenshotsSwiper": "_1-sJLG_screenshotsSwiper",
  "storeBtn": "_1-sJLG_storeBtn",
});
